import clsx from 'clsx';
import React from 'react';
import { useWindowSize } from 'usehooks-ts';

import SubscriptionOptionCard from '@components/SubscriptionOptionCard';
import { SelectedOffer } from '@utils/backend-api/subscribe';
import { getImgixSrc } from '@utils/images';

import styles from './planOptionsStyles.module.scss';

interface PlanOptionsProps {
  referralOffer: SelectedOffer;
  referringSubName?: string;
}

const PlanOptions = ({
  referralOffer: { currentPrice, originalPrice },
  referringSubName,
}: PlanOptionsProps) => {
  const { width } = useWindowSize();
  const cardsProps = {
    benefits: [
      "Reporting you won't find elsewhere",
      'Connect with subscribers in Directory & Forum',
      'A yearly subscription',
    ],
    length: 'Year',
    price: currentPrice,
    originalPrice: originalPrice,
    title: 'The Information Annual' as const,
    buttonText: 'Selected',
  };
  const desktopBannerImageUrl = getImgixSrc({
    path: '/referral/desktop_banner.png',
    isEnvDependent: false,
  });
  const mobileBannerImageUrl = getImgixSrc({
    path: '/referral/mobile_banner.png',
    isEnvDependent: false,
  });

  return (
    <div className={styles.subscriptionHeaderContainer}>
      <div className={clsx(styles.actionContainer)}>
        <img src={width > 768 ? desktopBannerImageUrl : mobileBannerImageUrl} width="100%" />
        <div className={clsx(styles.sectionWrapper, 'row')}>
          <div
            className={clsx(
              styles.sectionHeader,
              'col-xs-12 col-md-8 col-md-offset-2 col-lg-6 col-lg-offset-3'
            )}
          >
            {referringSubName && (
              <>
                <strong>{referringSubName}</strong> has shared 25% off access to the best news in
                tech.
              </>
            )}
          </div>
          <div className={clsx(styles.cardWrapper, 'col-xs-12')}>
            <div className={styles.cardContainer} id={cardsProps.title} key={cardsProps.title}>
              <SubscriptionOptionCard {...cardsProps} disableButton />
            </div>
          </div>
          <div
            className={clsx(
              styles.subscribeHeader,
              'col-xs-12 col-md-8 col-md-offset-2 col-lg-6 col-lg-offset-3',
              'mt-12 xs:mt-40'
            )}
          >
            Subscribe to The Information
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlanOptions;
